module.exports = __webpack_public_path__ + "static/python-d1563b773a4fdde003f2f67291c57248.png";